import deepEqual from 'fast-deep-equal';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { BaseFilterMenu } from '../BaseFilterMenu';
import { DEFAULT_OPERATOR } from './LightweightFilterMenu.constants';
import { ChipContent } from './components/ChipContent';
import { MenuContent } from './components/MenuContent';
export const LightweightFilterMenu = memo(({ id, className, fieldName, hideSelectAll, options, operatorOptions, onChange, values, operator, onRemove, label, isLoading, isInitiallyOpen, size, }) => {
    const [isOpen, setOpen] = useState(false);
    const [localValues, setLocalValues] = useState(values);
    const [localOperator, setLocalOperator] = useState(operator);
    useEffect(() => {
        setOpen(isInitiallyOpen);
    }, []);
    useEffect(() => {
        setLocalValues(values);
    }, [values]);
    useEffect(() => {
        setLocalOperator(operator);
    }, [operator]);
    const handleChipClick = useCallback(() => {
        setOpen(!isOpen);
    }, [isOpen]);
    const hasUnsavedChanges = useCallback(() => {
        return operator !== localOperator || !deepEqual(values.sort(), localValues.sort());
    }, [localOperator, localValues, operator, values]);
    const shouldUpdateGlobally = useCallback(() => {
        return localValues.length !== 0 || localOperator === DEFAULT_OPERATOR;
    }, [localOperator, localValues]);
    const discardChanges = useCallback(() => {
        setLocalValues(values);
        setLocalOperator(operator);
    }, [operator, values]);
    const handleClose = useCallback(() => {
        setOpen(false);
        if (!hasUnsavedChanges()) {
            return;
        }
        if (shouldUpdateGlobally()) {
            onChange(localValues, localOperator, fieldName);
        }
        else {
            discardChanges();
        }
    }, [hasUnsavedChanges, discardChanges, fieldName, localOperator, localValues, onChange, shouldUpdateGlobally]);
    const handleLocalValuesChange = (changedValues) => {
        setLocalValues(changedValues);
    };
    const handleLocalOperatorChange = (changedOperator) => {
        setLocalOperator(changedOperator);
    };
    return (React.createElement(BaseFilterMenu, { id: id, className: className, chipContent: React.createElement(ChipContent, { id: id, isOpen: isOpen, fieldName: fieldName, values: values, operator: operator, onRemove: onRemove, options: options, onChange: onChange, label: label }), menuContent: React.createElement(MenuContent, { id: id, fieldName: fieldName, hideSelectAll: hideSelectAll, operatorOptions: operatorOptions, operator: localOperator, values: localValues, options: options, onOperatorChange: handleLocalOperatorChange, onValuesChange: handleLocalValuesChange, isOpen: isOpen, isLoading: isLoading, label: label }), open: isOpen, onChipClick: handleChipClick, onClose: handleClose, size: size }));
});
//# sourceMappingURL=LightweightFilterMenu.js.map